import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Maritime() {
  const features = [
    {
      icon: 'ri-ship-line',
      title: 'Controlled Fleet',
      description: 'Fleet of 31 vessels including 15 self-propelled vessels, 12 non-self-propelled barges, and 4 push tugs.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Additional Resources',
      description: 'Access to 10 additional push tugs and 2 mobile oil pumping stations as required for operational flexibility.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety Standards',
      description: 'Full compliance with international maritime safety regulations and environmental standards.',
    },
    {
      icon: 'ri-route-line',
      title: 'Global Reach',
      description: 'Comprehensive coverage of major shipping routes and petroleum trading hubs worldwide.',
    },
    {
      icon: 'ri-time-line',
      title: 'Reliable Scheduling',
      description: 'Dependable transit times with coordinated scheduling for timely deliveries.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Professional Crew',
      description: 'Experienced maritime professionals ensuring safe and efficient operations.',
    },
  ];

  const fleetComposition = [
    { type: 'Self-Propelled Vessels', count: 15, icon: 'ri-ship-line' },
    { type: 'Non-Self-Propelled Barges', count: 12, icon: 'ri-sailboat-line' },
    { type: 'Push Tugs', count: 4, icon: 'ri-anchor-line' },
    { type: 'Additional Push Tugs (Available)', count: 10, icon: 'ri-anchor-line' },
    { type: 'Mobile Oil Pumping Stations', count: 2, icon: 'ri-oil-line' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section 
          className="relative min-h-[500px] flex items-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 20, 60, 0.7), rgba(0, 20, 60, 0.7)), url('https://public.readdy.ai/ai/img_res/f6df0a1e52f4579c70d7b1ddbd01c141.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">Maritime Shipping Services</h1>
            <p className="text-xl text-gray-200 max-w-3xl leading-relaxed">
              Controlled fleet of 31 vessels including self-propelled vessels, barges, and push tugs for comprehensive maritime petroleum transport
            </p>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://readdy.ai/api/search-image?query=Real%20oil%20tanker%20vessel%20fleet%20at%20port%20terminal%2C%20authentic%20maritime%20shipping%20photography%20with%20actual%20commercial%20tanker%20ships%20showing%20professional%20operations%20and%20modern%20infrastructure%2C%20professional%20documentary%20photograph%20of%20genuine%20petroleum%20transport%20vessels%20at%20harbor%20showing%20real%20maritime%20operations%20and%20safety%20standards%2C%20realistic%20photojournalism%20of%20working%20tanker%20ship%20fleet&width=600&height=400&seq=maritime-fleet-001&orientation=landscape"
                  alt="Maritime Fleet"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://readdy.ai/api/search-image?query=Real%20oil%20tanker%20vessel%20loading%20operations%20at%20industrial%20port%20terminal%2C%20authentic%20maritime%20shipping%20photography%20showing%20actual%20commercial%20tanker%20ship%20loading%20petroleum%20products%20with%20professional%20equipment%20and%20safety%20protocols%2C%20professional%20documentary%20photograph%20of%20genuine%20petroleum%20vessel%20operations%20at%20working%20harbor%20facility%2C%20realistic%20photojournalism%20of%20tanker%20loading&width=600&height=400&seq=maritime-loading-001&orientation=landscape"
                  alt="Loading Operations"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Real%20petroleum%20tanker%20vessel%20fleet%20at%20port%20terminal%2C%20authentic%20documentary%20photography%20of%20actual%20oil%20transport%20ships%20with%20company%20branding%2C%20professional%20photojournalism%20showing%20genuine%20maritime%20shipping%20operations%20with%20real%20vessels%20and%20port%20infrastructure%2C%20realistic%20commercial%20photograph%20of%20working%20tanker%20ship%20fleet&width=600&height=400&seq=maritime-fleet-001&orientation=landscape"
                  alt="Maritime Fleet"
                  className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
                />
              </div>
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">Professional Maritime Services</h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Our maritime shipping capabilities, managed by SHENZHEN TONCENT INT'L LOGISTICS CO.,LTD, include a controlled fleet of 31 vessels. This fleet comprises 15 self-propelled vessels, 12 non-self-propelled barges, and 4 push tugs, providing comprehensive maritime transportation solutions for petroleum products.
                </p>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  To ensure operational flexibility and scale, the company can also deploy an additional 10 push tugs and 2 mobile oil pumping stations as required. This extensive fleet capability allows us to handle diverse shipping requirements and adapt to varying operational demands.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Our maritime operations are conducted with the highest safety standards, ensuring secure and efficient transportation of petroleum products across global shipping routes. With experienced crews and modern vessels, we provide reliable maritime logistics solutions.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features Grid */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Maritime Service Features</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Comprehensive maritime transportation solutions with professional fleet management
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <div key={index} className="bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow">
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                    <i className={`${feature.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Fleet Composition */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Fleet Composition</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Diverse fleet capabilities for comprehensive maritime petroleum transportation
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {fleetComposition.map((item, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-6 flex items-center gap-4">
                  <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-blue-900">{item.count}</div>
                    <div className="text-gray-700 font-medium">{item.type}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Capabilities Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Maritime Capabilities</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Vessel Operations</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">Bulk Petroleum Transport:</strong>
                      <span className="text-gray-600"> Large-scale shipping of petroleum products</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">Coastal Shipping:</strong>
                      <span className="text-gray-600"> Regional distribution via coastal routes</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">International Routes:</strong>
                      <span className="text-gray-600"> Global shipping to major petroleum ports</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">Barge Operations:</strong>
                      <span className="text-gray-600"> Inland waterway and port-to-port transport</span>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Support Services</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">Mobile Pumping:</strong>
                      <span className="text-gray-600"> Flexible loading/unloading with mobile stations</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">Tug Services:</strong>
                      <span className="text-gray-600"> Vessel maneuvering and assistance</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">Cargo Monitoring:</strong>
                      <span className="text-gray-600"> Real-time tracking and status updates</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-blue-600 text-xl mt-1"></i>
                    <div>
                      <strong className="text-gray-900">Documentation:</strong>
                      <span className="text-gray-600"> Complete shipping documentation and compliance</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">Request Maritime Shipping</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Contact us to discuss your petroleum maritime transportation requirements
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get a Quote
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
